<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">new expense</small>
      </legend>
      <div>
        <form @submit.prevent="newExpense()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Account</label>
                <select class="form-control account_id" required>
                  <option value>Select account</option>
                  <option
                    v-for="accounttype in systemAccounttypes"
                    :value="accounttype.id"
                    :key="accounttype.id"
                  >{{ accounttype.account_name }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>
                  Expenses date
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control expenses_date input-rounded f-s-14"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Description</th>
                      <th scope="col">Truck</th>
                      <th scope="col">Unit</th>
                      <th scope="col">Unit price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Remarks</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(expense_product, k) in ExpenseitemsRows" :key="k">
                      <td scope="row">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteRow(k, expense_product)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, expense_product)"></i> -->
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="expense_product.expense_description"
                          required
                        />
                      </td>
                      <td>
                        <model-list-select
                         
                          :list="systemTrucks"
                          v-model="expense_product.truck_id"
                          option-value="id"
                          option-text="truck_no"
                          placeholder="select truck name"
                        ></model-list-select>
                      </td>
                      <td>
                        <select
                          name="product_measurement"
                          class="form-control input_rounded product_measurement"
                          v-model="expense_product.expense_measurement"
                        >
                          <option value>Select Measurement</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="PCS">PIECES</option>
                          <option value="LTS">LITRES</option>
                          <option value="SET">SET</option>
                          <option value="PAIR">PAIR</option>
                          <option value="MTR">METRES</option>
                          <option value="N/A">N/A</option>
                        </select>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="expense_product.unit_price"
                          @change="calculateLineTotal(expense_product)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="expense_product.qty"
                          @change="calculateLineTotal(expense_product)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="expense_product.remarks"
                          
                        />
                      </td>
                      <td>
                        <input
                          readonly
                          class="form-control text-right"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="expense_product.total_price"
                        />
                      </td>
                    </tr>
                    <tr v-show="ExpenseitemsRows.length === 0">
                      <td colspan="7">
                        <p class="text-center alert-danger p-2">No products added/available.</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7" class="text-right">Sub Total</td>
                      <input
                        readonly
                        class="form-control text-right sub_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_subtotal"
                      />
                    </tr>
                    <tr>
                      <td colspan="7" class="text-right">Total</td>
                      <input
                        readonly
                        class="form-control text-right expense_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_total"
                      />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addExpenseItems">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button type="submit" class="btn btn-primary btn-flat creatingExpense btn-rounded">
              <i class="fa fa-plus"></i> create Expense
            </button>
            <button type="button" class="btn-rounded btn-flat creatingExpenseLoader btn-rounded">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModelListSelect } from 'vue-search-select'
import router from "../router/index";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0
    };
  },
  created() {
    this.loadProduct();
    this.loadTrucks();
    this.loadAccounttypes();
  },
  computed: {
    ...mapGetters([
      "ExpenseitemsRows",
      "systemTrucks",
      "systemProducts",
      "systemAccounttypes"
    ])
  },
  methods: {
    ...mapActions([
      "newExpense",
      "loadTrucks",
      "loadProduct",
      "loadAccounttypes"
    ]),
    ...mapMutations(["addExpenseItems"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.ExpenseitemsRows.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(expense_product) {
      var total =
        parseFloat(expense_product.unit_price) *
        parseFloat(expense_product.qty);
      if (!isNaN(total)) {
        expense_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, expense_product) {
      var idx = this.ExpenseitemsRows.indexOf(expense_product);
      console.log(idx, index);
      if (idx > -1) {
        this.ExpenseitemsRows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  },
  components: {
      ModelListSelect
    }
};
</script>
<style scoped>
.creatingExpenseLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/expenses/expenses.vue